/* import __COLOCATED_TEMPLATE__ from './lottie-wrapper.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { LottiePlayer } from '@repo/design-system-kit/components/lottie-player/lottie-player';

export default class LottieWrapperComponent extends Component {
  lottiePlayer = LottiePlayer;

  @service sentry;

  get loop() {
    return this.args.loop || false;
  }

  @action
  handlerError(error) {
    if (Boolean(error.status) && error.status >= 400 && error.status < 500) {
      this.sentry.captureException(error);
    }
  }
}
